import { SDK } from 'download-user-documents'

import { env } from '@app/env'

export const downloadUserDocumentsSDK = () => {
  return new SDK(env.REACT_APP_DOWNLOAD_USER_DOCUMENTS_PUBLIC_URL)
}
